import { render } from "./Dashboard.vue?vue&type=template&id=212a934a&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=212a934a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-212a934a"

export default script